module.exports = __webpack_public_path__ + "static/media/displayphoto2.63d7002b.png";